"use client"

import styles from "./skip_to_content.module.scss"

export default function SkipToContent() {
    return (
        <a href="#main-content" className={styles.skip_link}>
            Skip to main content
        </a>
    )
}
